import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProjectList from "./components/AdminDashboard";
import LoginPage from "./components/LoginPage";


import 'katex/dist/katex.min.css';
import { pdfjs } from 'react-pdf';
import MCPDetail from "./components/MCPDetail";
import MCPEdit from "./components/MCPEdit";
import AgentDetail from "./components/AgentDetail";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={<ProjectList />} />
        <Route path="/mcp/:module_key" element={<MCPDetail/>} />
        <Route path="/mcp/:module_key/edit" element={<MCPEdit />} />
        <Route path="/agent/:agentId" element={<AgentDetail />} />
      </Routes>
    </Router>
  );
}

export default App;


// npm run build

// npm install -g serve
// serve -s build -l 3000
